import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";
import "firebase/auth";
import db from "../firebase/firebaseInit";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    sampleBlogCards: [
      {
        blogTitle: "الكارت 1",
        blogCoverPhoto: "stock-1",
        blogDate: "May 1 , 2021",
      },
      {
        blogTitle: "الكارت 2",
        blogCoverPhoto: "stock-2",
        blogDate: "May 1 , 2021",
      },
      {
        blogTitle: "الكارت 3",
        blogCoverPhoto: "stock-3",
        blogDate: "May 1 , 2021",
      },
      {
        blogTitle: "الكارت 4",
        blogCoverPhoto: "stock-4",
        blogDate: "May 1 , 2021",
      },
    ],
    blogHTML: "write your blog title here",
    blogTitle: "",
    blogPhotoName: "",
    blogPhotoFileURL: "",
    blogPhotoPreview: false,
    editPost: null,
    user: null,
    profileEmail: "",
    profileFirstName: "",
    profileUsername: "",
    profileId: null,
    profileInitials: "",
    profileLastName: "",
  },
  mutations: {
    openPhotoPreview(state) {
      state.blogPhotoPreview = !state.blogPhotoPreview;
    },
    newBlogPost(state, payload) {
      state.blogHTML = payload;
    },
    updateBlogTitle(state, payload) {
      state.blogTitle = payload;
    },
    fileNameChange(state, payload) {
      state.blogPhotoName = payload;
    },
    createFileUrl(state, payload) {
      state.blogPhotoFileURL = payload;
    },
    toggleEditPost(state, payload) {
      state.editPost = payload;
    },
    setProfileInfo(state, doc) {
      state.profileId = doc.id;
      state.profileEmail = doc.data().email;
      state.profileFirstName = doc.data().firstName;
      state.profileLastName = doc.data().lastName;
      state.profileUsername = doc.data().userName;
    },
    setProfileIntials(state) {
      state.profileInitials = `${state.profileFirstName.charAt(
        0
      )} ${state.profileLastName.charAt(0)}`;
    },
    updateUser(state, payload) {
      state.user = payload;
    },
    changeFirstName(state, payload) {
      state.profileFirstName = payload;
    },
    changeLastName(state, payload) {
      state.profileLastName = payload;
    },
    changeuserName(state, payload) {
      state.profileUsername = payload;
    },
  },
  actions: {
    async getCurrentUser({ commit }) {
      const dataBase = await db
        .collection("users")
        .doc(firebase.auth().currentUser.uid);
      const dbResults = await dataBase.get();
      commit("setProfileInfo", dbResults);
      commit("setProfileIntials");
      console.log(dbResults);
    },
    async updateUserSettings({ commit, state }) {
      const dataBase = await db.collection("users").doc(state.profileId);
      await dataBase.update({
        firstName: state.profileFirstName,
        lastName: state.profileLastName,
        userName: state.profileUsername,
      });
      commit("setProfileIntials");
    },
  },
  modules: {},
});
